import { useParams } from 'react-router-dom';

export default function useCurrentWorkflowId() {
  const { id } = useParams<{ id: string }>();
  if (!id) {
    throw new Error('useCurrentWorkflowId called outside of Workflow show route');
  }
  return id;
}
